<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <mat-tab-group class="tabs-group edit-order-grp">
    <mat-tab label="Expense Details">
      <div [formGroup]="form1" class="forms w-100 d-block expense-popup-info">
        <div class="row m-0">

          <div class="col-lg-12">
            @if (formAlert) {
              <div class="w-100 mb-3">
                <div class="w-100"
                  style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                  <p><b>{{formAlert}}</b></p>
                </div>
              </div>
            }
          </div>

          <div class="row">
            <div class="col-lg-4">
              <span class="p-float-label required-field w-100 mb-3">
                <p-dropdown dropdownIcon="fa fa-caret-down" [options]="orderProducts"
                  formControlName="orderProductId" id="orderProductId" optionLabel="name"
                  optionValue="orderProductId" [filter]="true" filterBy="name" [showClear]="false"
                  placeholder="Select Order Product" (onChange)="onProductSelect($event)">
                </p-dropdown>
                <label for="orderProductId">Order Product <span style="color: red">*</span></label>
                @for (validation of validationMessages.orderProductId; track validation) {
                  <span>
                    @if (form1.get('orderProductId').hasError(validation.type) && (form1.get('orderProductId').dirty || form1.get('orderProductId').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4">
              <span class="p-float-label required-field w-100 mb-3">
                <input formControlName="name" id="name" type="text" pInputText>
                <label for="name">Name <span style="color: red">*</span></label>
                @for (validation of validationMessages.name; track validation) {
                  <span>
                    @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>



            <div class="col-lg-4">
              <span class="p-float-label required-field amount-field w-100 mb-3">
                <p-inputNumber formControlName="amount" [minFractionDigits]="2"
                [maxFractionDigits]="4"></p-inputNumber>
                <label for="amount">Amount <span style="color: red">*</span></label>
                @for (validation of validationMessages.amount; track validation) {
                  <span>
                    @if (form1.get('amount').hasError(validation.type) && (form1.get('amount').dirty || form1.get('amount').touched)) {
                      <small id="name2-help" class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-4 mb-3">
              <span class="p-float-label w-100">
                <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="paidBys"
                  formControlName="paidBy" optionLabel="name" optionValue="value"
                placeholder="Paid By"></p-dropdown>
                <label for="paidBy">Paid By <span style="color: red">*</span></label>
              </span>
              @for (validation of validationMessages.paidBy; track validation) {
                <span>
                  @if (form1.get('paidBy').hasError(validation.type) && (form1.get('paidBy').dirty || form1.get('paidBy').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </div>

          </div>

          <div class="row">
            <div class="col-lg-4">
              <span class="p-float-label required-field w-100 mb-3">
                <input formControlName="quantity" id="quantity" type="number" pInputText>
                <label for="quantity">quantity</label>
                @for (validation of validationMessages.quantity; track validation) {
                  <span>
                    @if (form1.get('quantity').hasError(validation.type) && (form1.get('quantity').dirty || form1.get('quantity').touched)) {
                      <small id="name2-help" class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div class="col-lg-4">
              <span class="p-float-label required-field amount-field w-100 mb-3">
                <p-inputNumber formControlName="markUpPCT" mode="decimal" [minFractionDigits]="2"
                [maxFractionDigits]="6"></p-inputNumber>
                <label for="markUpPCT">MarkUp PCT</label>
                @for (validation of validationMessages.markUpPCT; track validation) {
                  <span>
                    @if (form1.get('markUpPCT').hasError(validation.type) && (form1.get('markUpPCT').dirty || form1.get('markUpPCT').touched)) {
                      <small id="name2-help" class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div class="col-lg-4">
              <span class="p-float-label required-field w-100 mb-3">
                <p-dropdown dropdownIcon="fa fa-caret-down" [options]="markupTypes"
                  formControlName="markUpType" id="markUpType" optionLabel="name" optionValue="value"
                  [showClear]="false" placeholder="Select MarkUp Type">
                </p-dropdown>
                <label for="markUpType">MarkUp Type</label>
                @for (validation of validationMessages.markUpType; track validation) {
                  <span>
                    @if (form1.get('markUpType').hasError(validation.type) && (form1.get('markUpType').dirty || form1.get('markUpType').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>


          <div class="row">
            <div class="col-lg-4">
              <span class="p-float-label required-field w-100 mb-3">
                <input formControlName="expenseId" id="expenseId" type="number" readonly="true" pInputText>
                <label for="expenseId">Expense Id</label>
              </span>
            </div>

            <div class="col-lg-4">
              <span class="p-float-label required-field w-100 mb-3">
                <input formControlName="expenseVendorId" id="expenseVendorId" type="text" pInputText>
                <label for="expenseVendorId">Expense Vendor Id</label>
              </span>
            </div>

            <div class="col-lg-4">
              <span class="p-float-label w-100 mb-3">
                <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="vendors"
                  formControlName="expenseVendor" optionLabel="name" optionValue="value"
                placeholder="Expense Vendor"></p-dropdown>
                <label for="expenseVendor">Expense Vendor</label>
                @for (validation of validationMessages.expenseVendor; track validation) {
                  <span>
                    @if (form1.get('expenseVendor').hasError(validation.type) && (form1.get('expenseVendor').dirty || form1.get('expenseVendor').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>



          <div class="row">
            <div class="col-lg-4">
              <span class="p-float-label w-100 mb-3">
                <p-calendar formControlName="expenseDetailDate" inputId="expenseDetailDate" appendTo="body">
                </p-calendar>
                <label for="expenseDetailDate">Expense Detail Date</label>
                @for (validation of validationMessages.expenseDetailDate; track validation) {
                  <span>
                    @if (form1.get('expenseDetailDate').hasError(validation.type) && (form1.get('expenseDetailDate').dirty || form1.get('expenseDetailDate').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-4">
              <span class="p-float-label w-100 mb-3">
                <p-calendar formControlName="vendorUpdateDateTime" inputId="vendorUpdateDateTime"
                [showTime]="true" [hourFormat]="'24'" appendTo="body"></p-calendar>
                <label for="vendorUpdateDateTime">Vendor Update Date Time</label>
                @for (validation of validationMessages.vendorUpdateDateTime; track validation) {
                  <span>
                    @if (form1.get('vendorUpdateDateTime').hasError(validation.type) && (form1.get('vendorUpdateDateTime').dirty || form1.get('vendorUpdateDateTime').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>


          <div class="row">
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="description" id="description" [rows]="2"
                pInputTextarea></textarea>
                <label for="description">Description</label>
                @for (validation of validationMessages.description; track validation) {
                  <span>
                    @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
                <label for="opsNotes">Ops Notes</label>
                @for (validation of validationMessages.opsNotes; track validation) {
                  <span>
                    @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
        </div>
      </div>
      <hr>
        <div class="row m-0">
          <div class="col-lg-12">
            <div class="btn-group">
              <div class="button-group">
                @if (expenseDetailId) {
                  <button pButton [class.disabled]="formLoading"
                    class="btn-delete p-button-outlined p-button-danger" (click)="onFormDelete()">
                    Delete
                  </button>
                }
              </div>

              <div class="button-group">
                <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                @if (!expenseDetailId) {
                  <button pButton [class.disabled]="formLoading"
                    class="btn-addt p-button" (click)="formAdd()">
                    {{!formLoading ? 'Add' : 'Adding...'}}
                  </button>
                }

                @if (expenseDetailId) {
                  <button pButton [class.disabled]="formLoading" class="btn-upt p-button"
                    (click)="formUpdate()">
                    {{!formLoading ? 'Update' : 'Updating...'}}
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="History">
        @if (expenseDetailId) {
          <app-audit-list
          [auditUrl]="'expenseDetails/' + expenseDetailId + '/audit'"></app-audit-list>
        }
      </mat-tab>
    </mat-tab-group>

  </div>